export const deleteFile = (payload?: any) => ({
    type: "@saga/DELETE_FILE",
    payload
});

